






























































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue')
  }
})
export default class MotorInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload

  get motorWeakFeelingOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  get motorStaggerOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  get motorFallingOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }
}
